import React, { useContext } from 'react';
import List from '@mui/material/List';
import { useTranslation } from 'react-i18next';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CropFreeIcon from '@mui/icons-material/CropFree';
import useRoutes from '../../components/_hook/useRoutes';
import DrawerListItem from '../../components/_header/DrawerListItem';
import Context from '../../context';

export default function CodeDrawer() {
  const { path } = useRoutes();
  const { company } = useContext(Context);
  const { t } = useTranslation();

  return (
    <>
      <List>
        <DrawerListItem
          path={path('code.dashboard', {
            companyID: company._id,
          })}
          primaryText={t('dashboard')}
          icon={<DashboardIcon />}
        />
        <DrawerListItem
          path={path('code.list', {
            companyID: company._id,
          })}
          primaryText={t('list')}
          icon={<CropFreeIcon />}
        />
      </List>
    </>
  );
}
